export enum InvoiceDiscountLevelDisplayId {
  NONE = "none",
  DAYS_91 = "days-91",
  DAYS_121 = "days-121",
  DAYS_181 = "days-181",
}

export enum PracticeTypeDisplayId {
  STANDARD = "standard",
  MANAGED = "managed",
}

export enum ProviderTypeDisplayId {
  STANDARD = "standard",
  MANAGED = "managed",
}
